import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Courses from './pages/courses/Courses';
import Contact from './pages/contact/Contact';
import Events from './pages/events/Events';
import Apply from './pages/apply/Apply';
import GetStarted from './pages/getstarted/GetStarted';
import ShortTermPage from './pages/courses/ShortTermPage';
import ProfessionalPage from './pages/courses/ProfessionalPage';
import JapaADSEPage from './pages/Japa/JapaADSEPage';
import './App.css';
import Nav from './layout/Nav';
import Footer from './layout/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/courses/career" element={<Courses/>} />
          <Route path="/courses/short-term" element={<ShortTermPage/>} />
          <Route path="/courses/professional" element={<ProfessionalPage/>} />
          <Route path="/courses/japawithadse" element={<JapaADSEPage/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/events" element={<Events/>} />
          <Route path="/apply" element={<Apply/>} />
          <Route path="/getstarted" element={<GetStarted/>} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
